/**
 * Analytics & ads cookie choice — one place for the banner and /cookie-policy.
 *
 * public/index.html reads the same localStorage key and sets Google consent
 * mode BEFORE the tags configure, so a decline sticks on every later visit.
 * These helpers apply a change to the current page immediately.
 */
const KEY = 'cookieConsent';

export function getCookieChoice() {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
}

export function setCookieChoice(choice) {
  const granted = choice === 'accepted';
  try { localStorage.setItem(KEY, granted ? 'accepted' : 'rejected'); } catch (e) { /* private mode */ }
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      const v = granted ? 'granted' : 'denied';
      window.gtag('consent', 'update', { analytics_storage: v, ad_storage: v, ad_user_data: v, ad_personalization: v });
    }
  } catch (e) { /* tracking must never break the page */ }
}
